import { Card } from './BmsCardPrimitives'

const ErrorDiamondIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
    <path d="M9.43271 17.7204C9.25007 17.645 9.0834 17.5363 8.93271 17.3942L2.60583 11.0673C2.46375 10.9166 2.355 10.7499 2.27958 10.5673C2.20431 10.3847 2.16667 10.1956 2.16667 10C2.16667 9.80444 2.20431 9.61319 2.27958 9.42625C2.355 9.23931 2.46375 9.07479 2.60583 8.93271L8.93271 2.60583C9.0834 2.45514 9.25007 2.34431 9.43271 2.27333C9.61535 2.20222 9.80444 2.16667 10 2.16667C10.1956 2.16667 10.3868 2.20222 10.5738 2.27333C10.7607 2.34431 10.9252 2.45514 11.0673 2.60583L17.3942 8.93271C17.5449 9.07479 17.6557 9.23931 17.7267 9.42625C17.7978 9.61319 17.8333 9.80444 17.8333 10C17.8333 10.1956 17.7978 10.3847 17.7267 10.5673C17.6557 10.7499 17.5449 10.9166 17.3942 11.0673L11.0673 17.3942C10.9252 17.5363 10.7607 17.645 10.5738 17.7204C10.3868 17.7957 10.1956 17.8333 10 17.8333C9.80444 17.8333 9.61535 17.7957 9.43271 17.7204ZM10.1844 16.5031L16.5031 10.1844C16.5459 10.1416 16.5673 10.0801 16.5673 10C16.5673 9.91986 16.5459 9.8584 16.5031 9.81563L10.1844 3.49687C10.1416 3.4541 10.0801 3.43271 10 3.43271C9.91986 3.43271 9.8584 3.4541 9.81563 3.49687L3.49688 9.81563C3.4541 9.8584 3.43271 9.91986 3.43271 10C3.43271 10.0801 3.4541 10.1416 3.49688 10.1844L9.81563 16.5031C9.8584 16.5459 9.91986 16.5673 10 16.5673C10.0801 16.5673 10.1416 16.5459 10.1844 16.5031ZM9.375 10.9054H10.625V6.22604H9.375V10.9054ZM10.4775 12.8894C10.6079 12.7591 10.6731 12.5999 10.6731 12.4119C10.6731 12.2238 10.6079 12.0647 10.4775 11.9344C10.3472 11.804 10.1881 11.7388 10 11.7388C9.81194 11.7388 9.65278 11.804 9.5225 11.9344C9.39208 12.0647 9.32688 12.2238 9.32688 12.4119C9.32688 12.5999 9.39208 12.7591 9.5225 12.8894C9.65278 13.0198 9.81194 13.085 10 13.085C10.1881 13.085 10.3472 13.0198 10.4775 12.8894Z" fill="currentColor" />
  </svg>
)

// Code-badge color follows the fault code's prefix letter (A=Alarm, P=Protection, F=Fault).
const CODE_COLORS = {
  A: { bg: '#c32925', text: '#f9fafa' },
  P: { bg: '#e0b52c', text: '#272d37' },
  F: { bg: '#d26200', text: '#f9fafa' },
}
const DEFAULT_CODE_COLOR = { bg: '#c32925', text: '#f9fafa' }

const FaultBadge = ({ code, title, severity }) => {
  const { bg, text } = CODE_COLORS[code?.[0]] || DEFAULT_CODE_COLOR
  return (
    <div className="bg-[#f9fafa] border border-[#dfe4ed] rounded-md flex items-stretch overflow-hidden shrink-0">
      <div className="w-9 flex items-center justify-center shrink-0" style={{ backgroundColor: bg, color: text }}>
        <span className="text-sm font-semibold">{code}</span>
      </div>
      <div className="flex flex-col items-start px-2 py-1 whitespace-nowrap">
        <span className="text-sm font-medium text-[#272d37]">{title}</span>
        <span className="text-xs font-normal text-[#616a79]">{severity}</span>
      </div>
    </div>
  )
}

const FaultsCard = ({ faults, className = '' }) => (
  <Card className={`${className} h-full`}>
    <span className="text-sm font-medium text-[#272d37] flex items-center gap-2">
      <ErrorDiamondIcon />
      Active Faults
    </span>
    {faults.length > 0 ? (
      <div className="flex flex-wrap gap-2 w-full">
        {faults.map((f, i) => (
          <FaultBadge key={i} {...f} />
        ))}
      </div>
    ) : (
      <div className="flex-1 flex items-center justify-center w-full text-sm font-medium text-[#616a79]">
        No active faults
      </div>
    )}
  </Card>
)

export default FaultsCard
